export default {
  // User authenticated
  authenticated: false,
  user: null,

  // Everything shows tags
  categoryNames: null,

  // Keep track if an internal route has been followed
  // so Back buttons know if they should really go 'back'
  routed: false,

  // Typeahead results
  typeaheadCurrentQuery: null,
  typeaheadResults: { foodItems: [], categories: [], query: '' },

  // i18n locale
  locale: localStorage.locale || 'es',

  // Notification message to show on next route change
  notify: {
    message: '',
    type: '',      // bulma type, e.g. is-success
  },
};



// WEBPACK FOOTER //
// ./src/store/state.js